import { Outlet } from '@tanstack/react-router';
import { PaywallOverlay } from '@/components/campaign';

/**
 * Every Fundraising page. Fundraising is a paid module, but it lives under /admin, outside the /app shell
 * that paywalls Field, Analytics and Work Orders — so it carries the same lock itself. The API already
 * refuses a lapsed campaign's Fundraising requests; this makes the page say why instead of looking broken.
 */
export function FundraisingLayout() {
  return (
    <PaywallOverlay>
      <Outlet />
    </PaywallOverlay>
  );
}
